import { PUT_PRIVACY } from './action';
import privacy from '../../translations/pl_PL/blog/privacy-policy.json';

function privacyReducer(state=privacy, action)
{
    switch (action.type) {
      case PUT_PRIVACY: 
        return action.payload;

      default:
        return state;
  }
}

export default privacyReducer;
